import { render, staticRenderFns } from "./config-suite-name-selector.vue?vue&type=template&id=d3d5835a&"
import script from "./config-suite-name-selector.vue?vue&type=script&lang=js&"
export * from "./config-suite-name-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports